export default __webpack_public_path__ + "static/5-applicazioni-machine-learning-aziende-c8980297042d5cd0c7143b7ae7f0f1c0.jpg";